import React, { useState } from "react";
import { Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import RangePicker from "../components/CustomComponents/RangePicker/RangePick"; // Use RangePick component
import "../styles/notification.scss";

type DateRange = [Date | null, Date | null];

interface Alert {
  alertLabel: string;
  alertTime: string;
  alertMsg: string;
  unread: boolean;
}

interface Notifications {
  notificationDay: string;
  messages: Alert[];
}

interface DayValue {
  year: number;
  month: number;
  day: number;
}

interface DayRange {
  from: DayValue | null;
  to: DayValue | null;
}

const NotificationPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<"all" | "unread">("all");
  const [dateFilter, setDateFilter] = useState<string>("today");
  const [dateRange, setDateRange] = useState<DateRange>([null, null]);
  const [selectedDayRange, setSelectedDayRange] = useState<DayRange>({
    from: null,
    to: null,
  });

  const Data: Notifications[] = [
    {
      notificationDay: "Today",
      messages: [
        {
          alertLabel: "Extended break time",
          alertTime: "2hr ago",
          alertMsg: "You exceeded the daily break limit by 30 minutes. The set limit is 1 hour.",
          unread: true,
        },
        {
          alertLabel: "Extended break time",
          alertTime: "2hr ago",
          alertMsg: "You exceeded the daily break limit by 30 minutes. The set limit is 1 hour.",
          unread: true,
        },
      ],
    },
    {
      notificationDay: "Yesterday",
      messages: [
        {
          alertLabel: "Extended break time",
          alertTime: "22-11-2024 | 01:52 PM",
          alertMsg: "You exceeded the daily break limit by 30 minutes. The set limit is 1 hour.",
          unread: false,
        },
        {
          alertLabel: "Extended break time",
          alertTime: "22-11-2024 | 01:52 PM",
          alertMsg: "You exceeded the daily break limit by 30 minutes. The set limit is 1 hour.",
          unread: false,
        },
        {
          alertLabel: "Extended break time",
          alertTime: "22-11-2024 | 01:52 PM",
          alertMsg: "You exceeded the daily break limit by 30 minutes. The set limit is 1 hour.",
          unread: false,
        },
        {
          alertLabel: "Extended break time",
          alertTime: "22-11-2024 | 01:52 PM",
          alertMsg: "You exceeded the daily break limit by 30 minutes. The set limit is 1 hour.",
          unread: false,
        },
      ],
    },
    {
      notificationDay: "Older",
      messages: [
        {
          alertLabel: "Extended break time",
          alertTime: "22-11-2024 | 01:52 PM",
          alertMsg: "You exceeded the daily break limit by 30 minutes. The set limit is 1 hour.",
          unread: false,
        },
        {
          alertLabel: "Extended break time",
          alertTime: "22-11-2024 | 01:52 PM",
          alertMsg: "You exceeded the daily break limit by 30 minutes. The set limit is 1 hour.",
          unread: false,
        },
        {
          alertLabel: "Extended break time",
          alertTime: "22-11-2024 | 01:52 PM",
          alertMsg: "You exceeded the daily break limit by 30 minutes. The set limit is 1 hour.",
          unread: false,
        },
      ],
    },
  ];

  const extractFirstLetters = (sentence = "") => {
    if (sentence !== "") {
      const words = sentence.split(" ");
      return (
        words[0]?.charAt(0)?.toUpperCase() +
        (words[1] ? words[1]?.charAt(0)?.toUpperCase() : "")
      );
    } else {
      return "";
    }
  };

  const unreadCount = Data.reduce(
    (acc, day) => acc + day.messages.filter((m) => m.unread).length,
    0
  );

  const filteredData = activeTab === "unread"
    ? Data.map(day => ({
      ...day,
      messages: day.messages.filter(m => m.unread)
    })).filter(day => day.messages.length > 0)
    : Data;

  const handleDateRange = (dateRange: DateRange) => {
    let [newFromDate, newToDate] = dateRange;
    let today = new Date();

    if (newFromDate === null && newToDate === null) {
      setDateFilter("today");
    } else {
      setDateFilter("Range");
    }

    setDateRange(dateRange);


  };

  const handleNotificationSettings = () => {
    navigate('/settings');
  };

  return (
    <div className="notification-page">
      {/* Header */}
      <div className="notification-header">
        <div className="header-content">
          <h1>Notifications</h1>
          <button className="settings-btn" onClick={handleNotificationSettings}>
            <Image
              src="/images/dashboard/settings.svg"
              alt="Settings"
            />
            <span>Notification settings</span>
          </button>
        </div>
      </div>

      {/* Tabs and Filter */}
      <div className="notification-tabs">
        <div className="tabs-content">
          <div className="tab-buttons">
            <button
              onClick={() => setActiveTab("all")}
              className={`tab-btn ${activeTab === "all" ? "active" : ""}`}
            >
              All
            </button>

            <button
              onClick={() => setActiveTab("unread")}
              className={`tab-btn ${activeTab === "unread" ? "active" : ""}`}
            >
              Unread
              <span className="unread-badge">{String(unreadCount).padStart(2, '0')}</span>
            </button>
          </div>

          {/* RangePicker Component with notification variant */}
          <div className="date-stt position-relative">
            <RangePicker
              value={selectedDayRange}
              onSelect={handleDateRange}
            // variant="notification"
            />
          </div>
        </div>
      </div>

      {/* Notifications List */}
      <div className="notifications-list">
        {filteredData.map((section, sectionIndex) => (
          <div key={sectionIndex} className="notification-section">
            <h2 className="section-title">{section.notificationDay}</h2>
            <div className="notification-card">
              {section.messages.map((message, messageIndex) => (
                <div
                  key={messageIndex}
                  className={`notification-item ${message.unread ? "unread" : ""}`}
                >
                  {/* Avatar with Indicator */}
                  <div className="avatar-container">
                    <div className="avatar">
                      {extractFirstLetters(message.alertLabel)}
                    </div>
                    {message.unread && (
                      <div className="unread-indicator"></div>
                    )}
                  </div>

                  {/* Content */}
                  <div className="notification-content">
                    <div className="content-header">
                      <h3 className="notification-title">
                        {message.alertLabel}
                      </h3>
                      <span className="notification-time">
                        {message.alertTime}
                      </span>
                    </div>
                    <p className="notification-message">
                      {message.alertMsg}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationPage;